import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../styles/EditCollectionSelectorPage.css";

const API =
  "https://squid-app-6s2hc.ondigitalocean.app";

export default function PublicCollectionsPage() {

  const navigate = useNavigate();
  const { username } = useParams();

  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    async function loadCollections() {

      try {

        const res = await fetch(
          `${API}/get-public-collections-for-user`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              username
            })
          }
        );

        const data = await res.json();

        if (res.ok) {
          setCollections(data.collections || []);
        }

      } finally {
        setLoading(false);
      }
    }

    loadCollections();

  }, [username]);

  if (loading) {
    return <div className="edit-selector-page">loading...</div>;
  }

if (loading) {
  return null;
}

return (
  <div className="edit-collection-page">
    <main className="edit-selector-page ready">

      <button
        className="contact-back"
        onClick={() => navigate(-1)}
      >
        ← back
      </button>

      <h1>
        ┌─ {username}'s{" "}
        <span className="highlight">
          collections
        </span>
      </h1>

      <div className="collection-list">

        {collections.map((col) => (
          <div
            key={col.publicSlug}
            className="collection-card"
            onClick={() =>
              navigate(`/p/${col.publicSlug}`)
            }
          >
            <div className="collection-info">

              <h2>
                {col.name}
              </h2>

              <p>
                {col.itemCount} items
              </p>

              <p className="collection-visibility">
                🔓 public
              </p>

            </div>
          </div>
        ))}

      </div>

    </main>
  </div>
);
}